export class Group {

    public name = '';
  
    constructor() { }
  
}